var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFullscreenOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "TOL-fullscreen_x5F_on_x5F_24",
    d: "M8,16h8V8H8V16z M9,9h6v6H9V9z M22,2v5l-1.8-1.8l-2.5,2.5l-1.4-1.4l2.5-2.5L17,2H22z  M5.2,3.8l2.5,2.5L6.3,7.7L3.8,5.2L2,7V2h5L5.2,3.8z M20.2,18.8L22,17v5h-5l1.8-1.8l-2.5-2.5l1.4-1.4L20.2,18.8z M7.7,17.7l-2.5,2.5 L7,22H2v-5l1.8,1.8l2.5-2.5L7.7,17.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFullscreenOn);
export default __webpack_public_path__ + "static/media/img_Fullscreen_on.493262fe8c3c6ed83a20aa61684644e4.svg";
export { ForwardRef as ReactComponent };